import { styled } from 'linaria/react';
import { useLocalization } from 'model/localization.model';
import { FunctionalComponent, h } from 'preact';
import { useEffect, useRef, useState } from 'preact/hooks';

import { Photo } from 'model/domain';
import { isBlob } from 'libs/is-blob';

type PhotoZoomProps = {
	photo: Photo;
	onClose: () => void;
}

export const EnlargePhoto: FunctionalComponent<PhotoZoomProps> = (props) => {
	const { photo, onClose } = props;

	const t = useLocalization();
	const imageRef = useRef<HTMLImageElement>(null);
	const [source, updateSource] = useState(null);
	const [width, updateWidth] = useState(0);
	const [maxWidth, updateMaxWidth] = useState(0);

	useEffect(() => {
		if (isBlob(photo)) {
			const urlCreator = window.URL || window.webkitURL;
			updateSource(urlCreator.createObjectURL(photo));
		} else {
			updateSource(photo);
		}
	}, [photo]);
	const onImageLoad =() => {
		if (!imageRef.current) {return;}

		const bounding = imageRef.current.getBoundingClientRect();
		updateMaxWidth(window.innerWidth);
		updateWidth(bounding.width);
	};

	return (
		<PhotoZoomWrapper>
			<img
				onLoad={onImageLoad}
				style={{
					maxWidth: maxWidth === 0 ?
						'initial' :
						maxWidth,
				}}
				ref={imageRef}
				src={source}
				alt="Photo preview"
			/>
			{/*{width > 0 && (*/}
			{/*	<RangeInput*/}
			{/*		type="range"*/}
			{/*		min={window.innerWidth}*/}
			{/*		max={width}*/}
			{/*		value={maxWidth}*/}
			{/*		onChange={(e) => updateMaxWidth(parseInt(e.target.value))}*/}
			{/*	/>*/}
			{/*)}*/}
			<EnlargeButton
				style={{
					position: 'fixed',
					bottom: 32,
					left: '50%',
					transform: 'translateX(-50%)',
				}}
				onClick={onClose}
			>
				<svg width="14" height="16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M12.68 6.29H9.36a.64.64 0 01-.65-.65V2.32c0-.18.15-.32.33-.32h.64c.18 0 .32.14.32.32V5h2.68c.18 0 .32.14.32.32v.64c0 .18-.14.33-.32.33zm-7.4-.65V2.32A.32.32 0 004.97 2h-.64a.32.32 0 00-.32.32V5H1.32a.32.32 0 00-.32.32v.64c0 .18.14.33.32.33h3.32c.36 0 .65-.3.65-.65zm0 8.04v-3.32a.64.64 0 00-.64-.65H1.32a.32.32 0 00-.32.33v.64c0 .18.14.32.32.32H4v2.68c0 .18.14.32.32.32h.64c.18 0 .33-.14.33-.32zm4.72 0V11h2.68c.18 0 .32-.14.32-.32v-.64a.32.32 0 00-.32-.33H9.36a.64.64 0 00-.65.65v3.32c0 .18.15.32.33.32h.64c.18 0 .32-.14.32-.32z"
						fill="#fff"/>
				</svg>
				{t('mobile.resubmission.zoomout')}
			</EnlargeButton>
		</PhotoZoomWrapper>
	);
};

const RangeInput = styled('input')`
	position: fixed;
	display: flex;
	align-items: center;
	justify-content: center;
    right: 16px;
    top: 50%;
    width: 50vh;
    transform: translateY(-50%) translateX(50%) rotate(-90deg);
    z-index: 100;
`;
export const EnlargeButton = styled('button')`
	display: flex;
	align-items: center;
	height: 26px;
	padding: 0 16px;
	background: rgba(0, 0, 0, .7);
	border: none;
	border-radius: 4px;
	outline: none;
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 20px;
	color: #FFFFFF;
	
	svg {
		margin-right: 8px;
	}
`;
const PhotoZoomWrapper = styled('div')`
	position: fixed;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	overflow: scroll;
	background: black;
`;
